import { GET } from "@/util/request";

export async function fetchDataApi(params = {}) {
  return await GET("/honeyee.php", params);
}



// WEBPACK FOOTER //
// src/api/common.js